// extracted by mini-css-extract-plugin
module.exports = {"root":"DialogTitle_root__3VgN7"};